// BlogPost1Page.js
import React from "react";
import Nav from "../../Nav";
import { Container, Typography, Box, Card, CardContent, CardMedia, Button, List, ListItem, ListItemText, Grid } from '@mui/material';
import blog4 from "../images/photo4_2.svg";
import pr1 from "../images/spanish1.jpg";
import pr2 from "../images/Madrid - Spain.jpg";
import { motion } from 'framer-motion';




const BlogPost4Page = ({ post }) => {
    return (
        <>
            <Nav />
            <Box sx={{ backgroundColor: '#f8fafc', py: 8, fontFamily: 'Arial, sans-serif' }}>
                <Box sx={{ py: 15, textAlign: 'center', color: '#000000' }} style={{ backgroundColor: '#f8fafc' }}>
                    <Container maxWidth="lg" style={{ backgroundColor: '#f8fafc' }}>
                        <Typography variant="h3" align="center" className='merriweather-bold' gutterBottom sx={{ fontWeight: 'bold' }}>
                            Spanish People Struggle with English Pronunciation
                        </Typography>
                        <div id="image-container" className="absolute top-20 left-0">
                            <img src='https://demo.edublink.co/wp-content/uploads/2023/05/shape-13.png' className="ml-4 mt-4" alt="Small Image" />
                        </div>
                        <div id="image-container2" className="absolute top-20 right-80">
                            <img src='https://demo.edublink.co/wp-content/uploads/2023/07/shape-37.png' className="h-32 w-32" alt='' />
                        </div>
                        <div id="image-container3" className="absolute top-120 right-40">
                            <img src='https://demo.edublink.co/wp-content/uploads/2023/05/shape-02.png' className="h-32 w-32" alt='' />
                        </div>
                        <div id="image-container3" className="absolute bottom-20 right-0">
                            <img src='https://demo.edublink.co/wp-content/themes/edublink/assets/images/shapes/breadcrumb-shape-3.png' className="h-48 w-32" alt='' />
                        </div>
                    </Container>
                </Box>

                <Container maxWidth="lg" sx={{ backgroundColor: '#ffffff', p: 5, borderRadius: 2, boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)', mt: -8 }}>
                    <Grid container spacing={5} alignItems="flex-start" mb={4}>
                        <Grid item xs={12} lg={6}>
                            <Typography variant="body1" paragraph sx={{ fontFamily: 'Arial, sans-serif', lineHeight: 1.6, color: '#6b778c' }}>
                                Spanish and English have some similarities in pronunciation, but there are also notable differences that Spanish speakers often find challenging when learning English.
                            </Typography>
                            <Typography variant="body1" paragraph sx={{ fontFamily: 'Arial, sans-serif', lineHeight: 1.6, color: '#6b778c' }}>
                                Here are some comparisons and examples:
                            </Typography>
                            <Typography variant="body1" paragraph sx={{ fontFamily: 'Arial, sans-serif', lineHeight: 1.6, color: '#6b778c' }}>
                                <b>Differences in Pronunciation:</b>
                            </Typography>
                            <Typography variant="body1" paragraph sx={{ fontFamily: 'Arial, sans-serif', lineHeight: 1.6, color: '#6b778c' }}>
                                <b>Vowel Sounds:</b>
                            </Typography>
                            <Typography variant="body1" paragraph sx={{ fontFamily: 'Arial, sans-serif', lineHeight: 1.6, color: '#6b778c' }} >
                                Spanish has five vowel sounds (/a/, /e/, /i/, /o/, /u/), which are consistent and relatively pure.
                                <i><b>English has more vowel sounds and diphthongs </b></i>(combinations of two vowel sounds within the same syllable), leading to potential confusion for Spanish speakers. For example, the English vowel sound in<i><b> "boat" (/oʊ/) or "bite" (/aɪ/) </b></i> may be difficult for Spanish speakers to master due to their absence in Spanish.
                            </Typography>
                        </Grid>
                        <Grid item xs={12} lg={6}>
                            <motion.div initial={{ scale: 0 }} animate={{ scale: 1 }} transition={{ duration: 0.5, delay: 0.2 }}>
                                <CardMedia
                                    component="img"
                                    image={blog4}
                                    alt="Fresh Start"
                                    sx={{ borderRadius: 2, boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)' }}
                                />
                            </motion.div>
                        </Grid>
                    </Grid>


                    <Typography variant="body1" paragraph sx={{ fontFamily: 'Arial, sans-serif', lineHeight: 1.6, color: '#6b778c' }}>
                        <b>Consonant Sounds:</b>
                    </Typography>

                    <Typography variant="body1" paragraph sx={{ fontFamily: 'Arial, sans-serif', lineHeight: 1.6, color: '#6b778c' }}>
                        Spanish consonants tend to be more consistent and phonetic compared to English.
                        English has certain consonant sounds that may not exist in Spanish or are pronounced differently. For instance, the "th" sounds (/θ/ as in "think" and /ð/ as in "this") are challenging for Spanish speakers because these sounds do not exist in Spanish.

                    </Typography>
                    <Typography variant="body1" paragraph sx={{ fontFamily: 'Arial, sans-serif', lineHeight: 1.6, color: '#6b778c' }}>
                        <b>Word Stress:</b> 
                    </Typography>
                    <Typography variant="body1" paragraph sx={{ fontFamily: 'Arial, sans-serif', lineHeight: 1.6, color: '#6b778c' }}>
                        Spanish generally places stress on the second-to-last syllable of a word, while English stress patterns can vary.
                    </Typography>
                    <Typography variant="body1" paragraph sx={{ fontFamily: 'Arial, sans-serif', lineHeight: 1.6, color: '#6b778c' }}>
                        <b><i>Learning English word stress patterns can be challenging for Spanish speakers,</i></b> leading to mispronunciations and difficulties in understanding. For example, the word "photograph" <b>(/ˈfoʊ.tə.ɡræf/)</b> with stress on the first syllable can be challenging for<u> Spanish speakers who might instinctively place stress on the second syllable.</u>
                    </Typography>
                    <Typography variant="body1" paragraph sx={{ fontFamily: 'Arial, sans-serif', lineHeight: 1.6, color: '#6b778c' }}>
                        <b>Examples of Difficult Words for Spanish Speakers:</b>
                    </Typography>
                    <Typography variant="body1" paragraph sx={{ fontFamily: 'Arial, sans-serif', lineHeight: 1.6, color: '#6b778c' }}>
                        <b>Thought:</b> The combination of the "th" sound and the final "t" can be challenging for Spanish speakers.<b> (/θɔːt/)</b>
                    </Typography>
                    <Typography variant="body1" paragraph sx={{ fontFamily: 'Arial, sans-serif', lineHeight: 1.6, color: '#6b778c' }}>
                        <b>Squirrel:</b> The cluster of consonants at the beginning of the word and the pronunciation of "r" can be difficult. <b>(/ˈskwɜːrəl/)</b>
                    </Typography>
                    <Typography variant="body1" paragraph sx={{ fontFamily: 'Arial, sans-serif', lineHeight: 1.6, color: '#6b778c' }}>
                        <b>Beach:</b> The diphthong "ea" and the final "ch" sound may pose challenges. <b>(/biːtʃ/)</b>
                    </Typography>
                    <Typography variant="body1" paragraph sx={{ fontFamily: 'Arial, sans-serif', lineHeight: 1.6, color: '#6b778c' }}>
                        <b>Sixth:</b> Pronouncing the cluster of consonants at the end of the word <b>(/sɪksθ/)</b> can be challenging for Spanish speakers.
                    </Typography>
                    <Typography variant="body1" paragraph sx={{ fontFamily: 'Arial, sans-serif', lineHeight: 1.6, color: '#6b778c' }}>
                        <b>Throughout:</b> The combination of "th" sounds and the unstressed syllable "out" <b>(/ðruːˈaʊt/)</b> can be difficult to master.
                    </Typography>

                    <Grid item xs={12} lg={11} container spacing={2}>
                        <Grid item xs={6} paddingBottom={'20px'}>
                            <motion.div
                                initial={{ scale: 0 }}
                                animate={{ scale: 1 }}
                                transition={{ duration: 0.5, delay: 0.2 }}
                            >
                                <CardMedia
                                    component="img"
                                    image={pr1}
                                    alt="Fresh Start"
                                    sx={{ borderRadius: 2, height: 300, marginTop: '10px' }}
                                />
                            </motion.div>
                        </Grid>
                        <Grid item xs={6}>
                            <motion.div
                                initial={{ scale: 0 }}
                                animate={{ scale: 1 }}
                                transition={{ duration: 0.5, delay: 0.2 }}
                            >
                                <CardMedia
                                    component="img"
                                    image={pr2}
                                    alt="Fresh Start"
                                    sx={{ borderRadius: 2, height: 300, marginTop: '10px' }}
                                />
                            </motion.div>
                        </Grid>
                    </Grid>

                </Container >
            </Box >
        </>
    );
};

export default BlogPost4Page;
